const PREVIEW_CENTER_PATH_COLOR = '#F59E0B'
const PREVIEW_SLOT_PATH_COLOR = '#27B5FF'

function appendPathGeometryFeatures(geoJSON, geometry) {
    if (!geometry?.coordinates) {
        return
    }

    const addLine = (coordinates, isCenterLine) => {
        geoJSON.features.push({
            type: 'Feature',
            properties: {
                name: isCenterLine ? 'center_path' : 'slot_path',
                stroke: isCenterLine ? PREVIEW_CENTER_PATH_COLOR : PREVIEW_SLOT_PATH_COLOR,
                strokeWidth: isCenterLine ? 2 : 1,
                fill: 'none',
            },
            geometry: {
                type: 'LineString',
                coordinates,
            },
        })
    }

    if (geometry.type === 'LineString') {
        addLine(geometry.coordinates, false)
        return
    }

    if (geometry.type === 'MultiLineString') {
        geometry.coordinates.forEach((line, index) => {
            addLine(line, index === 0)
        })
    }
}

export const transformBordersToGeoJSON = (data) => {
    let geoJSON = {
        type: 'FeatureCollection',
        features: [],
    }

    Object.keys(data).forEach((key) => {
        try {
            if (key === 'outer_border' || key === 'outerBorder') {
                if (data[key]) {
                    geoJSON.features.push({
                        type: 'Feature',
                        properties: {
                            name: key,
                        },
                        geometry: {
                            type: data[key].type,
                            coordinates: data[key].coordinates,
                        },
                    })
                }
            } else if (key === 'path') {
                appendPathGeometryFeatures(geoJSON, data[key])
            } else if (key === 'paths' && Array.isArray(data[key])) {
                data[key].forEach(pathItem => {
                    appendPathGeometryFeatures(geoJSON, pathItem?.geometry ?? pathItem)
                })
            }
        } catch (error) {
            console.error(data, key)
        }
    })
    return geoJSON
}
